/* globals console, document, module, require, window */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
/* jscs:disable disallowDanglingUnderscores */
'use strict';

const Backbone = require('backbone'),
    BackboneRadio = require('backbone.radio'),
    jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    templates = require('../utilities/handlebars').templates,
    _ = require('lodash'),
    //
    Contexts = require('./contexts'),
    Dashboard = require('./dashboard'),
    Header = require('./header'),
    Html = require('./html'),
    ModalDialog = require('./modalDialog'),
    ProgramDetails = require('./programDetails'),
    Programs = require('./programs'),
    ShareDialog = require('./shareDialog'),
    //
    Program = require('../models/program'),
    user = require('../models/user'),
    configuration = require('../utilities/configuration'),
    //
    Router = require('../utilities/router'),
    AnalyticsRadio = require('../utilities/analyticsRadio'),
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'container main' + (configuration.embedded ? ' embedded' : '') // + ' role-guest'
    },
    // className: 'container',
    channels: {
        router: BackboneRadio.channel('router'),
        analytics: BackboneRadio.channel('analytics'),
        vaultIn: BackboneRadio.channel('vaultInterface:in'),
        vaultOut: BackboneRadio.channel('vaultInterface:out')
    },
    childViewEvents: {
        'jump:reports': 'onJumpReports'
    },
    regions: {
        contexts:   {el: 'div[name=contexts]',   replaceElement: true},
        dashboard:  {el: 'div[name=dashboard]',  replaceElement: true},
        header:     {el: 'div[name=header]',     replaceElement: true},
        programs:   {el: 'div[name=programs]',   replaceElement: true},
        // footer:     {el: 'div[name=footer]',     replaceElement: true},
        programDetailsPopout: {el: 'div[name=programDetailsPopout]',   replaceElement: true}
    },
    tagName: 'div',
    template: templates.container,
    //
    destroyChildView: function (region) {
        const childView = this.getChildView(region);
        if (childView) {
            childView.destroy();
        }
    },
    initialize: function () {
        // const allCapabilities = _.map(user.allCapabilities(), function (capability) { return 'role-' + capability;}).join(' ');
        // fire up Google Analytics
        if (!configuration.embedded) {
            jQuery('html').addClass('standalone');
        }
        this.analyticsRadio = new AnalyticsRadio();
        // tell Google Analytics what platform we're running on
        // this.channels.analytics.trigger('variable', { key: 'dimension3', value: configuration._configuration_ }); /* places_platform */  // obsolete
        this.router = new Router();
        this.listenTo(this.channels.router, 'newRoute', _.bind(this.onNewRoute, this));
        jQuery('body').addClass('role-' + user.highestCapability());
        this.listenTo(user, 'change:roles', _.bind(function () {
            const organizationOnlyRoutes = {
                    administrators: true,
                    dashboard: true,
                    organizations: true,
                    reports: true
                };
            // tell Google Analytics what our greatest capability is. GA can slice and dice all reports on this variable.
            // this.channels.analytics.trigger('variable', { key: 'dimension2', value: user.highestCapability() }); /* places_role */ // obsolete
            // apply a class high-up identifying the user's highest capability
            // _.each(user.allCapabilities(), _.bind(function (capability) { this.$el.removeClass('role-' + capability); }, this));
            jQuery('body').removeClass(function (index, classNames) {
                // return allCapabilities;
                return (classNames.match(/role\-[a-z]*/g) || []).join(' ');
            });
            jQuery('body').addClass('role-' + user.highestCapability());
            // see if we have any business being on the dashboard still - but look for the dashboard explicitly to allow both programs and popout program
            if (organizationOnlyRoutes[Backbone.history.getFragment()] && !user.hasCapability('organization')) {
                // console.log('Container: Routing back to #programs');
                if (this.getChildView('dashboard')) {
                    this.getChildView('dashboard').close();
                }
                this.router.navigate('programs', {trigger: true});
            }
        }, this));
        // global click handler for external links
        jQuery(document).on('click', 'a[href^="http://"], a[href^="https://"], a[href^="//"]', _.bind(this.onExternalLink, this));
        // global click handler for links requesting scrolling
        jQuery(document).on('click', 'a[href].scroll-to', _.bind(this.onRequestScroll, this));
        // global click handler for links to signal an analytics event
        jQuery(document).on('click', '[data-analytics]', _.bind(this.onAnalyticsClick, this));
        // global modal handler
        jQuery(document).on('show.bs.modal', 'div.modal', _.bind(this.onModalShow, this));
        jQuery(document).on('hide.bs.modal', 'div.modal', _.bind(this.onModalHide, this));
        // global click handler for rts_share
        jQuery(document).on('click', 'a[href^="rts_share:"]', _.bind(function (event) {
            const dataset = event.currentTarget.dataset,
                shareDialog = new ShareDialog({label: dataset.label, mode: dataset.mode, href: dataset.href, url: dataset.url, modalModal: dataset.modalModal === 'true', focus: dataset.focus});
            return false;
        }, this));
        // ye olde focus sniffer...
        // window.setInterval(function () {
        //     const e = jQuery(':focus');
        //     console.log(e, e.length);
        // }, 5000);
    },
    onAttach: function () {
        console.timeEnd('start:');
    },
    onJumpReports: function (options) {
        console.log('onJumpReports', options);
    },
    onNewRoute: function (options) {
        const toggleView = _.bind(function (view) {
                let programs;
                if (!this.dashboardProgramsShown) {
                    // console.log('container.dashboardProgramsShown');
                    if (!configuration.embedded && !configuration.disabledViews.contexts) {
                        this.showChildView('contexts', new Contexts());
                    }
                    this.showChildView('header', new Header({programs: true}));
                    programs = this.showChildView('programs', new Programs());
                    this.showChildView('dashboard', new Dashboard({filteredPrograms: programs.programs}));
                    // this.showChildView('footer', new Html({template: 'footer', class: 'footer mb-2'}));
                    this.dashboardProgramsShown = true;
                }
                this.getChildView('dashboard').$el[view === 'dashboard' ? 'show' : 'hide']();
                this.getChildView('programs').$el[view === 'programs' ? 'show' : 'hide']();
                this.getChildView('header').mode(view);
            }, this);
        // log the page view.
        this.channels.analytics.trigger('pageview', options.name);
        jQuery('body').toggleClass('popout', options.name.indexOf('popout') !== -1);
        switch (options.name) {
            case 'popout':
                this.showProgram(options);
                break;
            case 'dashboard':
                toggleView('dashboard');
                this.getChildView('dashboard').showPanel(options.panel);
                this.dashboardShown = true;
                break;
            case 'popoutPrograms':
                this.showChildView('programs', new Programs({popout: true}));
                break;
            case 'programs':
                toggleView('programs');
                if (this.dashboardShown && !this.programsShown) {
                    // current mental model is that google maps stays at zoom 0 if progamMaps is not visible
                    // therefore, we nudge the map the first time we arrive at programs from dashboard
                    this.getChildView('programs').mapNudge();
                }
                this.programsShown = true;
                break;
            default:
                break;
        }
    },
    onRequestScroll: function (event) {
        // when embedded, links requesting internal scrolling must be transformed into requests to the host to scroll
        if (configuration.embedded) {
            let target = jQuery(jQuery(event.target).attr('href'));
            if (target.length > 0) {
                event.preventDefault();
                this.channels.vaultOut.trigger('scrollToTop', {offset: target.offset().top});
            }
        }
        // otherwise, let the click proceed
    },
    onExternalLink: function (event) {
        // 1) Log the external click to analytics
        this.channels.analytics.trigger('event', {
            category: 'Clicks',
            action: 'Offsite',
            label: event.currentTarget.href
        });
        // 2) Set the target to _blank
        event.currentTarget.target = '_blank';
        // 3) Let the click proceed
    },
    onAnalyticsClick: function (event) {
        // 1) log the event to analytics
        this.channels.analytics.trigger('event', _.assign({
            category: 'places.click',
            action: 'action',
            label: event.currentTarget.href
        }, jQuery(event.currentTarget).data('analytics'))); // presumes data-analytics to be a JSON string...
        // 2) let the click proceed
    },
    onModalShow: function (event) {
        this.channels.vaultOut.trigger('scrollToTop', { offset: 0 });
        jQuery('div[data-name=application]').prop('inert', true);
    },
    onModalHide: function (event) {
        jQuery('div[data-name=application]').prop('inert', false);
    },
    showProgram: function (options) {
        // console.log('container.showProgram - options:%s', JSON.stringify(options));
        const model = new Program();
        this.listenTo(model, 'change', _.bind(function () {
            // @acavan! - restore 'popout: options.popout' and open programDetails with program details for popout === false
            this.showChildView('programDetailsPopout', new ProgramDetails({model: model, popout: options.popout}));
        }, this));
        // model.programDetails = true;
        model.fetch({id: options.id});
    }
});
